import { useEffect, useState } from "react";
import { Layout, Menu, Select, Spin } from "antd";
import {
  RightOutlined,
  LeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { CurrencySymbolDataAPI } from "../services/api";

const { Content, Sider } = Layout;
const { Option } = Select;

function PriceChart({
  nextrades_api_url,
  selectedEvent,
  timezone,
  theme,
  domain,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [symbolsList, setSymbolsList] = useState([]);
  const [symbol, setSymbol] = useState("");

  const getCurrencySymbols = async () => {
    setIsLoading(true);
    try {
      let res = await CurrencySymbolDataAPI({ id: selectedEvent.id });
      if (res.status) {
        let list = Object.keys(res.currencySymbolArry);
        setSymbolsList(list);
        setSymbol(list[0].replace("/", ""));
      }
    } catch (err) {
      console.log("err getCurrencySymbols - Price Chart", err);
    } finally {
      setIsLoading(false);
    }
  };

  const onCollapse = (x) => {
    setCollapsed(x);
  };

  useEffect(() => {
    getCurrencySymbols();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEvent]);

  let timezoneDisplay =
    Number(timezone) > 0 ? `-${timezone}` : `+${-Number(timezone)}`;

  let timezoneInMin = Number(-timezone) * 60;

  let formattedTime = moment().utcOffset(timezoneInMin).format("dddd H:mm:ss");

  // let isMobileScreen = window.innerWidth < 768

  let iframeUrl = `https://nextrades.ai/chartiq-nextrades/economic-calendar-price-chart.html#domain=${domain}&symbol=${symbol}`;
  // let iframeUrl = `http://127.0.0.1:5500/economic-calendar-price-chart.html#domain=${domain}&symbol=${symbol}`; // DEBUG
  iframeUrl += `&theme=day`; // DEBUG - Temporary
  iframeUrl += "&spreadGroup=Q-INTL"; // DEBUG - Temporary

  return (
    <div className="row">
      <div className="col-12 bg-light py-3 fs-6">
        <div className="d-flex flex-row align-items-center justify-content-between px-3">
          <div className="d-flex flex-row align-items-center">
            <div className="bold_text">Past Events</div>
            <div className="px-2">
              <Select value={symbol} onChange={(value) => setSymbol(value)}>
                {symbolsList.map((item, index) => (
                  <Option value={item.replace("/", "")} key={index}>
                    {item}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="d-flex flex-row align-items-center">
            <small className="mx-3">
              {formattedTime} GMT{timezoneDisplay}
            </small>
          </div>
        </div>
      </div>
      <div className="col-12 text-center">
        {isLoading ? (
          <Spin
            indicator={
              <LoadingOutlined style={{ fontSize: 50 }} spin className="mt-5" />
            }
          />
        ) : (
          <Layout>
            <Layout className="site-layout">
              {/* <Content style={{ margin: "0 16px" }}> */}
              <iframe
                title="Price Chart"
                // src={`https://gfx-i.net/chartiq/index.html?symbol=${symbol}&hidesearchbox=true&hidepricebox=true`}
                src={iframeUrl}
                width="100%"
                height="500"
                frameBorder="0"
              ></iframe>
              {/* </Content> */}
            </Layout>
            <Sider
              theme="light"
              collapsible
              collapsed={collapsed}
              onCollapse={onCollapse}
              collapsedWidth={0}
              zeroWidthTriggerStyle={{
                width: 30,
                height: 30,
                backgroundColor: "#0369dd",
                left: -30,
                top: 50,
                lineHeight: "inherit",
                fontSize: "inherit",
              }}
              trigger={
                collapsed ? (
                  <LeftOutlined className="text-white" />
                ) : (
                  <RightOutlined className="text-white" />
                )
              }
              className="price_chart_sider"
            >
              <div className="p-3 text-start bg-light">
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <div>
                    <img
                      src={selectedEvent?.flag}
                      alt={selectedEvent?.regionCode}
                      className="flagImg mr-1"
                    />
                    <span className="mx-2">{selectedEvent?.regionCode}</span>
                  </div>
                  <span className="px-2 bg-white fs-smaller">
                    {selectedEvent?.importance?.toUpperCase()}
                  </span>
                </div>
                <div className="fw-bold mt-1">{selectedEvent?.eventTitle}</div>
              </div>
              <Menu theme="light" defaultSelectedKeys={["1"]} mode="inline">
                {/* <Menu.Item key="1">Event Coming soon...</Menu.Item> */}
                {/* <Menu.Item key="2">Event Coming soon...</Menu.Item> */}
              </Menu>
            </Sider>
          </Layout>
        )}
      </div>
    </div>
  );
}

export default PriceChart;
